import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components/macro";
import { useLocation } from "react-router";
import Swal from "sweetalert2";

import Quiz from "../components/Quiz";

import sentences from "../data/vita300.json";
import shuffle from "../utils/shuffle";

const Main = styled.main`
  min-height: 100%;

  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: center;

  padding: 0rem 10rem;
  box-sizing: border-box;

  @media screen and (max-width: 900px) {
    padding: 2rem 2rem;
  }
`;

const Progress = styled.p`
  color: #adb5bd;
  font-size: 1.3rem;
`;

export default function QuizPage() {
  const location = useLocation();
  const history = useHistory();

  const { range, limit } = location.state as {
    range: { from: number; to: number };
    limit: number;
  };

  const actualSentences = sentences
    .slice(range.from - 1, range.to)
    .filter((s) => limit >= s.sentence.length);

  const [shuffled] = useState(shuffle(actualSentences));
  const [correctCount, setCorrectCount] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [wrongNumbers, setWrongNumbers] = useState<number[]>([]);

  if (location.state === undefined) {
    history.push("/");
    return null;
  }

  async function onSubmit(answer: string) {
    let newWrongNumbers = wrongNumbers;

    if (answer.trim() === shuffled[currentIndex].sentence.trim()) {
      setCorrectCount(correctCount + 1);
    } else {
      await Swal.fire({
        icon: "error",
        title: "틀렸습니다!",
        html:
          "정답 : " +
          shuffled[currentIndex].sentence +
          "<br/>입력 : " +
          (answer.length > 0 ? answer : "(비어있음)"),
        allowEnterKey: false,
        heightAuto: false,
      });
      newWrongNumbers = wrongNumbers.concat(shuffled[currentIndex].number);
      setWrongNumbers(newWrongNumbers);
    }

    if (currentIndex === shuffled.length - 1) {
      await Swal.fire({
        icon: "success",
        title: "수고하셨습니다!",
        html:
          "틀린 문장 번호들 : " +
          (newWrongNumbers.length > 0 ? newWrongNumbers.join(", ") : "없음!"),
        allowEnterKey: false,
        heightAuto: false,
      });
      history.push("/");
    } else {
      setCurrentIndex(currentIndex + 1);
    }
  }

  return (
    <Main>
      <Progress>
        {shuffled.length}문장 중 {currentIndex + 1}번째
      </Progress>
      <Quiz
        sentence={shuffled[currentIndex].sentence}
        meaning={shuffled[currentIndex].meaning}
        sentenceNumber={shuffled[currentIndex].number}
        correctCount={correctCount}
        onSubmit={onSubmit}
      />
    </Main>
  );
}
